import { render, staticRenderFns } from "./DetailKasbonApproval.vue?vue&type=template&id=32ca9136"
import script from "./DetailKasbonApproval.vue?vue&type=script&lang=js"
export * from "./DetailKasbonApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports